import { render, staticRenderFns } from "./CertificadoSites.vue?vue&type=template&id=2bf3d0e2"
import script from "./CertificadoSites.vue?vue&type=script&lang=js"
export * from "./CertificadoSites.vue?vue&type=script&lang=js"
import style0 from "./CertificadoSites.vue?vue&type=style&index=0&id=2bf3d0e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports